export default {"src":"/_next/static/media/avatar_cat.20f90ebd.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};